import { IContent } from '~src/spacesPlatform/models/IContent';

import { Request } from '../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../httpClient/serverApi/types/IGetItemsResult';
import { IUser } from '../../userManagement/users/serverApi/types/IUser';

export interface ExploreContentParams extends IGetItemsParams {
  project?: string;
}

export interface IExploreContentResult extends IGetItemsResult {
  content: IContent[];
  users: IUser[];
}

export class ExploreFavoritedContentForUserRequest extends Request<ExploreContentParams, IExploreContentResult> {
  constructor(params: ExploreContentParams) {
    super('exploreFavoritedContentForUser', params);
  }
}
